import { render, staticRenderFns } from "./GroupBuyRecordList.vue?vue&type=template&id=17a7afb4&scoped=true"
import script from "./GroupBuyRecordList.vue?vue&type=script&lang=js"
export * from "./GroupBuyRecordList.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyRecordList.vue?vue&type=style&index=0&id=17a7afb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a7afb4",
  null
  
)

export default component.exports